module.exports = __webpack_public_path__ + "static/img/5.3dc7a29.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/1/sp/5.png
// module id = HLm1
// module chunks = 0